<template>
    <div>
        <NewsWidget
            v-if="props.selectedWidgets.includes('news')"
            class="mt-3 mb-3"
        />
        <div class="dashboard-grid">
            <mrr-widget
                v-if="props.selectedWidgets.includes('mrr')"
            />
            <TasksWidget
                v-if="props.selectedWidgets.includes('tasks') && userPermissions.includes('task.manage')"
            />
            <PsaOrdersWidget
                v-if="props.selectedWidgets.includes('psa_orders') && userPermissions.includes('order.view')"
            />
            <CustomersPerBrandWidget
                v-if="props.selectedWidgets.includes('customers_per_brand')"
            />
            <OneWebshopOrdersWidget
                v-if="props.selectedWidgets.includes('one_webshop_orders') && userPermissions.includes('order.view')"
            />
            <div
                v-else-if="selectedWidgets.length === 0"
            >
                <DCard
                    padding
                >
                    {{ __('messages.dashboard.widgets.no_widgets_selected') }}
                </DCard>
            </div>
        </div>
        <AdminWidget
            v-if="props.selectedWidgets.includes('admin') && userPermissions.includes('widget.admin')"
            class="mt-3"
        />
        <DFabs>
            <DFab
                id="btn-release"
                :icon="'cog-outline'"
                :label="__('messages.dashboard.change_dashboard_settings')"
                @click="$inertia.get($route('settings.dashboard-settings.create'))"
            />
        </DFabs>
    </div>
</template>

<script setup>
import MrrWidget from '~@/Components/Dashboard/Widgets/MrrWidget.vue'
import TasksWidget from '~@/Components/Dashboard/Widgets/TasksWidget.vue'
import PsaOrdersWidget from '~@/Components/Dashboard/Widgets/PsaOrdersWidget.vue'
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import AdminWidget from '~@/Components/Dashboard/Widgets/Admin/AdminWidget.vue'
import CustomersPerBrandWidget from '~@/Components/Dashboard/Widgets/CustomersPerBrandWidget.vue'
import NewsWidget from '~@/Components/Dashboard/Widgets/News/NewsWidget.vue'
import OneWebshopOrdersWidget from '~@/Components/Dashboard/Widgets/OneWebshopOrdersWidget.vue'

const props = defineProps({
    selectedWidgets: {
        type: Array,
        default () {
            return []
        }
    }
})

const userPermissions = computed(() => usePage().props.auth.permissions)
</script>

<style>
.dashboard-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
}
</style>
